import React, { useEffect, useState, useRef } from 'react';
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";
import Accordion from 'react-bootstrap/Accordion';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HttpHelper from '../../service/httpService'
import Loader from '../../Components/Loader';
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";

const SecurityObjectName = 'Website.Factsheet';

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,FontName,
    FormatBlock,
    Link,
    Unlink,
    ViewHtml,
    InsertTable,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell,
} = EditorTools;

const DashboardFachSheet = (props) => {

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const [factsheet, setFactsheet] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [isEditing, setIsEditing] = useState(false);
    const [contentData, setContentData] = useState("");
    const [factsheetImage, setFactsheetImage] = useState(null);
    const [factIdUpdate, setFactIdUpdate] = useState();
    const [fileIdUpdate, setFileIdUpdate] = useState();
    const [fileDetailsUpdate, setFileDetailsUpdate] = useState();
    const [rowVersion, setRowVersion] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);

    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');
    const editor = useRef();

    const getHtml = () => {
        const view = editor.current.view;
        setValue("content", EditorUtils.getHtml(view.state))
    };

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("FactSheet/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        if (factIdUpdate !== '') {
                            FactsheetUpdate(data, factIdUpdate, fileIdUpdate, response.data[0]);
                        }
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                    setLoaderApi(false);
                })
            } else {

                FactsheetUpdate(data, factIdUpdate, fileIdUpdate, fileDetailsUpdate);
                //props.showToast('error', 'Please add image');
            }
        } else {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("FactSheet/UploadFileAsync", { 'Folder': 'FactSheet', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        FactsheetAdd(data, data.FileId)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                    setLoaderApi(false);
                })
            }
        }

    };

    const FactsheetAdd = async (data, fileId) => {
        if (fileId) {
            await HttpHelper.post("FactSheet", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                props.showToast('success', 'Record Added Succesfully');
            }).catch((error) => {
                setLoaderApi(false);
            })
        } else {
            await HttpHelper.post("FactSheet", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                props.showToast('success', 'Record Added Succesfully');
            }).catch((error) => {
                setLoaderApi(false);
            })
        }

    }

    const FactsheetUpdate = async (data, factIdUpdate, fileId, fileDetails) => {
        Object.assign(data, { rowVersion: rowVersion }, { primaryKeyEncrypted: primaryKeyEncrypted }, { FactId: factIdUpdate }, { FileId: fileId }, { file: fileDetails });
        console.log(data);

        await HttpHelper.put("FactSheet", data).then((response) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetFactSheet();
            BlankDetails();
            props.showToast('success', 'Record Updated Succesfully');
        }).catch((error) => {
            setLoaderApi(false);
        })
    }

    const GetFactSheet = async (data) => {
        setLoaderApi(true);
        await HttpHelper.get("FactSheet", data).then((response) => {
            setFactsheet(response.data.data);
            getAllPermission();
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
            setLoaderApi(false);
        })

    }
    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("FactSheet/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    const UpdateEditFactsheet = async (elem) => {

        setPopupAddEdit(true);
        setLoaderApi(true);

        setIsEditing(true);
        setShowLoader(true);

        await HttpHelper.get("FactSheet/" + elem).then((response) => {
            setValue('Heading', response.data.heading);
            setValue('FactsheetHeading', response.data.factsheetHeading);
            setValue('ImgHeading', response.data.imgHeading);
            setValue('Order', response.data.order);
            setValue('Content', response.data.content);
            setContentData(response.data.content);
            setFactIdUpdate(response.data.factId);
            setRowVersion(response.data.rowVersion);
            setFileIdUpdate(response.data.fileId);
            setFileDetailsUpdate(response.data.file);
            setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted)
            if (response.data.file !== null) {
                console.log(response.data.file.fileUrl)
                setFactsheetImage(response.data.file.fileUrl)
            } else {
                setFactsheetImage(null)
            }
            setShowLoader(false);
            accordianStatusHandle('1');

            setPopupAddEdit(true);
            setLoaderApi(false);

        }).catch((error) => {
            setShowLoader(false);
            console.log(error);
        })
    }
    const DeleteFactsheetById = (id) => {
        swal("Are you sure, you want to delete this banner?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    setIsEditing(false);
                    formRef.current.reset();
                    await HttpHelper.delete("FactSheet/" + id).then((response) => {
                        if (response.status === 200) {
                            props.showToast('success', 'Banner Deleted successfully');
                            GetFactSheet();
                        } else {
                            props.showToast('error', response.data);
                            console.log(response.data);
                        }
                    }).catch((error) => {
                        props.showToast('error', error.response.data);
                        console.log(error);
                    })
                }
            }
            );
    }
    const BlankDetails = () => {
        setIsEditing(false)
        setValue('FactsheetHeading', '');
        setValue('Heading', '');
        setValue('ImgHeading', '');
        setValue('Order', '');
        setValue('Content', '');
        setContentData('');
        setValue('file', '');
        setFactIdUpdate('');
        setRowVersion('');
        setPrimaryKeyEncrypted('')
        setShowLoader(false)
        setFileIdUpdate('');
        setFileDetailsUpdate('');
    }
    const accordianStatusHandle = (elem) => {
        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }
    useEffect(() => {
        GetFactSheet();
        setIsEditing(true);
    }, []);

    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="FactSheet List" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            {hasAddPermissionUser == true ?
                                <div className="col-auto">
                                    <button onClick={() => {
                                        BlankDetails();
                                        setPopupAddEdit(true);
                                        accordianStatusHandle('1');
                                    }} className="btn btnSave">Add Factsheet</button>
                                </div> : ''}
                            <div className="col-md-12 mb-2">
                            </div>
                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Order
                                                </th>
                                                <th>
                                                    Title
                                                </th>
                                                <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                    Image
                                                </th>
                                                <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                factsheet.length > 0 && factsheet.map((elem, index) => {
                                                    return (
                                                        <tr key={index} className="col-md-12 mb-2">
                                                            <td>{index + 1} </td>
                                                            <td>{elem.heading}</td>
                                                            <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                {
                                                                    elem.file && elem.file.fileUrl ? < img src={elem.file.fileUrl} width="30" height="30" /> : null
                                                                }
                                                            </td>
                                                            <td style={{ verticalAlign: 'center', textAlign: 'center' }} >

                                                                {hasEditPermissionUser == true ? <CiEdit onClick={() => { UpdateEditFactsheet(elem.primaryKeyEncrypted) }} /> : ''}
                                                                {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { DeleteFactsheetById(elem.factId) }} /> : ''}
                                                                                                                                
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                                : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageCurrentShow('');
                }}>
                    <RxCross1 />
                </div>
                <img src={imageCurrentShow} />
            </div>

            {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                <div className="popupEditAndAddForm">
                    <div className="popupEditAndAddFormCloseButton" onClick={() => {
                        setPopupAddEdit(false);
                        setIsEditing(true);
                    }} >
                        <RxCross2 />
                    </div>

                    {loaderApi == true ? <div className="loaderApi">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(1 1)" stroke-width="2">
                                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </div> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                        <div className="cardBox ">
                            <h4>{isEditing === true ? "Update Fact Sheet" : "Create Fact Sheet"}</h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Factsheet Heading:</label>
                                    <input type="text"  {...register("FactsheetHeading")} className="border mb-2" placeholder="Heading" />
                                </div>
                                <div className="col-md-6">
                                    <label>Factsheet Order: </label>
                                    <input type="text"  {...register("Order")} className="border mb-2" placeholder="Order" />
                                </div>

                                <div className="col-md-6">
                                    <label>Heading : <span class="requiredAstric"> *</span></label>
                                    <input type="text"  {...register("Heading", { required: true })} className="border mb-2" placeholder="Heading" aria-invalid={errors.Heading ? "true" : "false"} />
                                    {errors.Heading?.type === 'required' && <p className="text-danger" role="alert">Heading is required</p>}
                                </div>

                                <div className="col-md-6">
                                    <label>Image Heading : <span class="requiredAstric"> *</span></label>
                                    <input type="text"  {...register("ImgHeading", { required: true })} className="border mb-2" placeholder="Image Heading" aria-invalid={errors.ImgHeading ? "true" : "false"} />
                                    {errors.ImgHeading?.type === 'required' && <p className="text-danger" role="alert">Image Heading is required</p>}
                                </div>

                                <div className="col-md-12">
                                    <label>File : {isEditing == true ? <span class="requiredAstric"> *</span> : ''}</label>
                                    <br />
                                    <label>{fileDetailsUpdate != null ? fileDetailsUpdate.originalFileName : ''} </label>
                                    <input type="file"  {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100 is-invalid" />
                                    {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}

                                    <label>Content : <span class="requiredAstric"> *</span></label>
                                    <Editor className="border" placeholder="Content"
                                        tools={[
                                            [Bold, Italic, Underline, Strikethrough],
                                            [Subscript, Superscript],
                                            [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                            [Indent, Outdent],
                                            [OrderedList, UnorderedList],
                                            FontSize,FontName,
                                            FormatBlock,
                                            [Undo, Redo],
                                            [Link, Unlink, ViewHtml],
                                            [InsertTable],
                                            [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                            [DeleteRow, DeleteColumn, DeleteTable],
                                            [MergeCells, SplitCell],
                                        ]}
                                        ref={editor}
                                        defaultContent={contentData}
                                    />
                                    </div>
                                    <div className="col-md-12 d-flex justify-content-end mt-6">
                                        <div>
                                            <button className="btn btnSave mt-2" onClick={getHtml}>Save</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </form>}

                </div>
            </div> : ''}
        </DashboardWrapper>
    )
}

export default DashboardFachSheet;